/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable arrow-body-style */
import { Box, Container, Flex, Image, Text } from "@chakra-ui/react";

const SponsorsLayout = () => {
	return (
		<Box width="100%" mb="100px">
			<Box bg="#197542" py="80px" w="100%">
				<Text
					fontWeight="700"
					fontSize={{ xs: "26px", md: "48px" }}
					lineHeight="130%"
					color="#fff"
					textAlign="center"
				>
					Official Partners
				</Text>
			</Box>
			<Container maxW="container.lg" my="50px">
				<Box>
					<Text
						fontWeight="700"
						fontSize={{ xs: "24px", md: "28px" }}
						lineHeight="130%"
						color="#197542"
						textAlign="left"
						mb="2rem"
						borderLeft="3px solid #197542"
						pl="10px"
					>
						Gold Partner
					</Text>
					<Flex flexDirection="column" my="30px">
						<Flex
							w="100%"
							gap="50px"
							flexDirection={{ xs: "column", md: "row" }}
						>
							<a href="https://www.accel.com/" rel="noreferrer" target="_blank">
								<Box
									role="group"
									cursor="pointer"
									border="1px solid #EDEDED"
									w="220px"
									h="170px"
									py={3}
									display="flex"
									alignItems="center"
									justifyContent="center"
									flexDirection="column"
									boxShadow="0px 4px 84px rgba(100, 100, 140, 0.13)"
								>
									<Image
										h="full"
										w="150px"
										src="https://static.levocdn.com/WGLBUT82/6996030679917600787.jpg"
										alt="ivca"
										p={5}
									/>

									<Text
										variant="infoText"
										fontSize="18px"
										color="#46564A"
										borderColor="#46564A"
										borderTop="1px solid"
										w="full"
										textAlign="center"
										pt="10px"
										// pb="20px"
										_groupHover={{
											color: "text.green",
											cursor: "pointer",
										}}
									>
										Accel
									</Text>
								</Box>
							</a>{" "}
							<a href="https://neevfund.com/" rel="noreferrer" target="_blank">
								<Box
									role="group"
									cursor="pointer"
									border="1px solid #EDEDED"
									w="220px"
									h="170px"
									py={3}
									display="flex"
									alignItems="center"
									justifyContent="center"
									flexDirection="column"
									boxShadow="0px 4px 84px rgba(100, 100, 140, 0.13)"
								>
									<Image
										h="full"
										w="full"
										src="https://static.levocdn.com/WGLBUT82/SVL-New-Logo-5AQuZxbmcs5p.png"
										alt="ivca"
										p={5}
										objectFit="contain"
									/>
									<Image
										h="full"
										w="full"
										mt="-30px"
										src="https://static.levocdn.com/WGLBUT82/NeevFundNewLogo-4JOKlpgDBaYD.png"
										alt="ivca"
										p={5}
										objectFit="contain"
									/>

									<Text
										variant="infoText"
										fontSize="18px"
										color="#46564A"
										borderColor="#46564A"
										borderTop="1px solid"
										w="full"
										textAlign="center"
										pt="10px"
										// pb="20px"
										_groupHover={{
											color: "text.green",
											cursor: "pointer",
										}}
									>
										Neev Fund
									</Text>
								</Box>
							</a>
							<a
								href="https://www.sundaramalternates.com/Home"
								rel="noreferrer"
								target="_blank"
							>
								<Box
									role="group"
									cursor="pointer"
									border="1px solid #EDEDED"
									w="220px"
									h="170px"
									py={3}
									display="flex"
									alignItems="center"
									justifyContent="center"
									flexDirection="column"
									boxShadow="0px 4px 84px rgba(100, 100, 140, 0.13)"
								>
									<Image
										h="full"
										w="full"
										src="https://static.levocdn.com/WGLBUT82/SundaramAlternatesUpdatedLogo-BwjBoGuPnAVV.png"
										alt="ivca"
										p={5}
										objectFit="contain"
									/>

									<Text
										variant="infoText"
										fontSize="18px"
										color="#46564A"
										borderColor="#46564A"
										borderTop="1px solid"
										w="full"
										textAlign="center"
										pt="10px"
										// pb="20px"
										_groupHover={{
											color: "text.green",
											cursor: "pointer",
										}}
									>
										Sundaram Alternates
									</Text>
								</Box>
							</a>
						</Flex>
					</Flex>
				</Box>
				<Box>
					<Text
						fontWeight="700"
						fontSize={{ xs: "24px", md: "28px" }}
						lineHeight="130%"
						color="#197542"
						textAlign="left"
						mb="2rem"
						borderLeft="3px solid #197542"
						pl="10px"
					>
						Knowledge Partner
					</Text>
					<Flex flexDirection="column" my="30px">
						<Flex
							w="100%"
							gap="50px"
							flexDirection={{ xs: "column", md: "row" }}
						>
							<a
								href="https://www.ey.com/en_in"
								rel="noreferrer"
								target="_blank"
							>
								<Box
									role="group"
									cursor="pointer"
									border="1px solid #EDEDED"
									w="220px"
									h="170px"
									py={3}
									display="flex"
									alignItems="center"
									justifyContent="center"
									flexDirection="column"
									boxShadow="0px 4px 84px rgba(100, 100, 140, 0.13)"
								>
									<Image
										h="full"
										w="150px"
										src="https://static.levocdn.com/WGLBUT82/EYParthenonLogoPrimarySTFWCRGBLightEN-GLUUtccXBtXHF.png"
										objectFit="contain"
										alt="ivca"
										p={5}
									/>

									<Text
										variant="infoText"
										fontSize="18px"
										color="#46564A"
										borderColor="#46564A"
										borderTop="1px solid"
										w="full"
										textAlign="center"
										pt="5px"
										// pb="20px"
										_groupHover={{
											color: "text.green",
											cursor: "pointer",
										}}
									>
										EY Parthenon
									</Text>
								</Box>
							</a>

							<a
								href="https://www.herbertsmithfreehills.com/"
								rel="noreferrer"
								target="_blank"
							>
								<Box
									role="group"
									cursor="pointer"
									border="1px solid #EDEDED"
									w="220px"
									h="170px"
									py={3}
									display="flex"
									alignItems="center"
									justifyContent="center"
									flexDirection="column"
									boxShadow="0px 4px 84px rgba(100, 100, 140, 0.13)"
								>
									<Image
										h="full"
										w="150px"
										src="https://static.levocdn.com/WGLBUT82/logo-WT00rjNveIAo.svg"
										objectFit="contain"
										alt="ivca"
										p={5}
									/>

									<Text
										variant="infoText"
										fontSize="18px"
										color="#46564A"
										borderColor="#46564A"
										borderTop="1px solid"
										w="full"
										textAlign="center"
										pt="5px"
										// pb="20px"
										_groupHover={{
											color: "text.green",
											cursor: "pointer",
										}}
									>
										Herbert Smith Freehills
									</Text>
								</Box>
							</a>
							<a href="https://trilegal.com/" rel="noreferrer" target="_blank">
								<Box
									role="group"
									cursor="pointer"
									border="1px solid #EDEDED"
									w="220px"
									h="170px"
									py={3}
									display="flex"
									alignItems="center"
									justifyContent="center"
									flexDirection="column"
									boxShadow="0px 4px 84px rgba(100, 100, 140, 0.13)"
								>
									<Image
										h="full"
										w="150px"
										src="https://static.levocdn.com/WGLBUT82/TRILEGALBLUElogo-011-LkpnrHyTZoTOg.png"
										objectFit="contain"
										alt="ivca"
										p={5}
									/>

									<Text
										variant="infoText"
										fontSize="18px"
										color="#46564A"
										borderColor="#46564A"
										borderTop="1px solid"
										w="full"
										textAlign="center"
										pt="5px"
										// pb="20px"
										_groupHover={{
											color: "text.green",
											cursor: "pointer",
										}}
									>
										Trilegal
									</Text>
								</Box>
							</a>
						</Flex>
					</Flex>
				</Box>
				<Box>
					<Text
						fontWeight="700"
						fontSize={{ xs: "24px", md: "28px" }}
						lineHeight="130%"
						color="#197542"
						textAlign="left"
						mb="2rem"
						borderLeft="3px solid #197542"
						pl="10px"
					>
						Supporting Partner
					</Text>
					<Flex flexDirection="column" my="30px">
						<Flex
							w="100%"
							gap="50px"
							flexDirection={{ xs: "column", md: "row" }}
							flexWrap="wrap"
						>
							{/* <a
                href="https://www.advantedge.vc/"
                rel="noreferrer"
                target="_blank"
              >
                <Box
                  role="group"
                  cursor="pointer"
                  border="1px solid #EDEDED"
                  w="220px"
                  h="170px"
                  py={3}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  flexDirection="column"
                  boxShadow="0px 4px 84px rgba(100, 100, 140, 0.13)"
                >
                  <Image
                    h="full"
                    w="full"
                    src="https://static.levocdn.com/WGLBUT82/64d1ea38c58206c07f18624dlogo-XZbabFEQJsh7.png"
                    alt="ivca"
                    p={5}
                    objectFit="contain"
                  />

                  <Text
                    variant="infoText"
                    fontSize="18px"
                    color="#46564A"
                    borderColor="#46564A"
                    borderTop="1px solid"
                    w="full"
                    textAlign="center"
                    pt="5px"
                    // pb="20px"
                    _groupHover={{
                      color: 'text.green',
                      cursor: 'pointer',
                    }}
                  >
                    AdvantEdge Partners
                  </Text>
                </Box>
              </a> */}
							<a href="https://b.capital/" rel="noreferrer" target="_blank">
								<Box
									role="group"
									cursor="pointer"
									border="1px solid #EDEDED"
									w="220px"
									h="170px"
									py={3}
									display="flex"
									alignItems="center"
									justifyContent="center"
									flexDirection="column"
									boxShadow="0px 4px 84px rgba(100, 100, 140, 0.13)"
								>
									<Image
										h="full"
										w="full"
										src="https://static.levocdn.com/WGLBUT82/BCapital-newlogo-JtaeEtihFfxz.jpg"
										alt="ivca"
										p={5}
										objectFit="contain"
									/>

									<Text
										variant="infoText"
										fontSize="18px"
										color="#46564A"
										borderColor="#46564A"
										borderTop="1px solid"
										w="full"
										textAlign="center"
										pt="5px"
										// pb="20px"
										_groupHover={{
											color: "text.green",
											cursor: "pointer",
										}}
									>
										B Capital Group
									</Text>
								</Box>
							</a>
							<a
								href="https://eversourcecapital.com/"
								rel="noreferrer"
								target="_blank"
							>
								<Box
									role="group"
									cursor="pointer"
									border="1px solid #EDEDED"
									w="220px"
									h="170px"
									py={3}
									display="flex"
									alignItems="center"
									justifyContent="center"
									flexDirection="column"
									boxShadow="0px 4px 84px rgba(100, 100, 140, 0.13)"
								>
									<Image
										h="full"
										w="full"
										src="https://static.levocdn.com/WGLBUT82/Screenshot2024-11-08at105056PM-ZnMaUQRRl9k2.png"
										alt="ivca"
										p={5}
										objectFit="contain"
									/>

									<Text
										variant="infoText"
										fontSize="18px"
										color="#46564A"
										borderColor="#46564A"
										borderTop="1px solid"
										w="full"
										textAlign="center"
										pt="5px"
										// pb="20px"
										_groupHover={{
											color: "text.green",
											cursor: "pointer",
										}}
									>
										Eversource
									</Text>
								</Box>
							</a>
							<a
								href="https://www.khaitanco.com/"
								rel="noreferrer"
								target="_blank"
							>
								<Box
									role="group"
									cursor="pointer"
									border="1px solid #EDEDED"
									w="220px"
									h="170px"
									py={3}
									display="flex"
									alignItems="center"
									justifyContent="center"
									flexDirection="column"
									boxShadow="0px 4px 84px rgba(100, 100, 140, 0.13)"
								>
									<Image
										h="full"
										w="full"
										src="https://static.levocdn.com/WGLBUT82/Khaitan-Co-Indian-law-firm-busines-law-768x512-CISCrOfQ811f.jpg"
										alt="ivca"
										p={0}
										objectFit="contain"
										mb="-15px"
									/>

									<Text
										variant="infoText"
										fontSize="18px"
										color="#46564A"
										borderColor="#46564A"
										borderTop="1px solid"
										w="full"
										textAlign="center"
										pt="5px"
										// pb="20px"
										_groupHover={{
											color: "text.green",
											cursor: "pointer",
										}}
									>
										Khaitan & Co
									</Text>
								</Box>
							</a>
							<a
								href="https://gefcapital.com/"
								rel="noreferrer"
								target="_blank"
							>
								<Box
									role="group"
									cursor="pointer"
									border="1px solid #EDEDED"
									w="220px"
									h="170px"
									py={3}
									display="flex"
									alignItems="center"
									justifyContent="center"
									flexDirection="column"
									boxShadow="0px 4px 84px rgba(100, 100, 140, 0.13)"
								>
									<Image
										h="full"
										w="full"
										src="https://static.levocdn.com/WGLBUT82/7070002528428754732.png"
										alt="ivca"
										p={5}
										objectFit="contain"
									/>

									<Text
										variant="infoText"
										fontSize="18px"
										color="#46564A"
										borderColor="#46564A"
										borderTop="1px solid"
										w="full"
										textAlign="center"
										pt="5px"
										// pb="20px"
										_groupHover={{
											color: "text.green",
											cursor: "pointer",
										}}
									>
										GEF
									</Text>
								</Box>
							</a>
							<a
								href="https://www.vidaworld.com/"
								rel="noreferrer"
								target="_blank"
							>
								<Box
									role="group"
									cursor="pointer"
									border="1px solid #EDEDED"
									w="220px"
									h="170px"
									py={3}
									display="flex"
									alignItems="center"
									justifyContent="center"
									flexDirection="column"
									boxShadow="0px 4px 84px rgba(100, 100, 140, 0.13)"
								>
									<Image
										h="full"
										w="full"
										src="https://static.levocdn.com/WGLBUT82/Vida-Logo--PBH---CTC02-oilwrVbY4fO4.png"
										alt="ivca"
										p={5}
										objectFit="contain"
									/>

									<Text
										variant="infoText"
										fontSize="18px"
										color="#46564A"
										borderColor="#46564A"
										borderTop="1px solid"
										w="full"
										textAlign="center"
										pt="5px"
										// pb="20px"
										_groupHover={{
											color: "text.green",
											cursor: "pointer",
										}}
									>
										Hero MotoCorp
									</Text>
								</Box>
							</a>
							<a
								href="https://leapfroginvest.com/"
								rel="noreferrer"
								target="_blank"
							>
								<Box
									role="group"
									cursor="pointer"
									border="1px solid #EDEDED"
									w="220px"
									h="170px"
									py={3}
									display="flex"
									alignItems="center"
									justifyContent="center"
									flexDirection="column"
									boxShadow="0px 4px 84px rgba(100, 100, 140, 0.13)"
								>
									<Image
										h="full"
										w="full"
										src="https://static.levocdn.com/WGLBUT82/leapfrog-investments-seeklogo-JtaZEtihwFwd.png"
										alt="ivca"
										p={5}
										objectFit="contain"
									/>

									<Text
										variant="infoText"
										fontSize="18px"
										color="#46564A"
										borderColor="#46564A"
										borderTop="1px solid"
										w="full"
										textAlign="center"
										pt="5px"
										// pb="20px"
										_groupHover={{
											color: "text.green",
											cursor: "pointer",
										}}
									>
										Leapfrog Investments
									</Text>
								</Box>
							</a>
							<a
								href="https://www.peakxv.com/"
								rel="noreferrer"
								target="_blank"
							>
								<Box
									role="group"
									cursor="pointer"
									border="1px solid #EDEDED"
									w="220px"
									h="170px"
									py={3}
									display="flex"
									alignItems="center"
									justifyContent="center"
									flexDirection="column"
									boxShadow="0px 4px 84px rgba(100, 100, 140, 0.13)"
								>
									<Image
										h="full"
										w="150px"
										src="https://static.levocdn.com/WGLBUT82/PeakLogoPOSRGB11-eg6wOlkt3QcFJ.png"
										alt="ivca"
										p={5}
										objectFit="contain"
									/>

									<Text
										variant="infoText"
										fontSize="18px"
										color="#46564A"
										borderColor="#46564A"
										borderTop="1px solid"
										w="full"
										textAlign="center"
										pt="5px"
										// pb="20px"
										_groupHover={{
											color: "text.green",
											cursor: "pointer",
										}}
									>
										Peak XV
									</Text>
								</Box>
							</a>
							<a
								href="https://www.strideventures.global/"
								rel="noreferrer"
								target="_blank"
							>
								<Box
									role="group"
									cursor="pointer"
									border="1px solid #EDEDED"
									w="220px"
									h="170px"
									py={3}
									display="flex"
									alignItems="center"
									justifyContent="center"
									flexDirection="column"
									boxShadow="0px 4px 84px rgba(100, 100, 140, 0.13)"
								>
									<Image
										h="full"
										w="200px"
										src="https://static.levocdn.com/WGLBUT82/Screenshot2024-12-02at15151PM-FUGNXjd2D0Ra.png"
										alt="ivca"
										p={0}
										objectFit="contain"
									/>

									<Text
										variant="infoText"
										fontSize="18px"
										color="#46564A"
										borderColor="#46564A"
										borderTop="1px solid"
										w="full"
										textAlign="center"
										pt="5px"
										// pb="20px"
										_groupHover={{
											color: "text.green",
											cursor: "pointer",
										}}
									>
										Stride Ventures
									</Text>
								</Box>
							</a>
						</Flex>
					</Flex>
				</Box>
			</Container>
		</Box>
	);
};

export default SponsorsLayout;
